import { Button, Drawer, Hairline } from "@components";
import { useEffect, useMemo, useState } from "react";
import { InputSearch } from "shared/components/InputSearch";

import styles from "@styles/pages/cdp/filters.module.scss";

import classNames from "classnames/bind";
import { ForEach } from "shared/components/control-statements";
import { CustomerAttributeTextForm } from "./forms/CustomerAttributeTextForm";
import { VariableForms } from "./VariableForms";
import { Variables } from "./Variables";
const css = classNames.bind(styles);

export const ModifierTypes = {
  bt: {
    value: "bt",
    name: "Entre",
  },
  like: {
    value: "like",
    name: "Contém",
  },
  in_last: {
    value: "in_last",
    name: "Nos últimos",
  },
  month: {
    value: "month",
    name: "Mês",
  },
  in_next: {
    value: "in_next",
    name: "Nos próximos",
  },
};

export const Conditions = ({ condition, onChange, types }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={styles.collapseCategoryType}>
      <div
        className={css({
          selectedCategory: true,
          collapsed: collapsed,
        })}
        onClick={() => setCollapsed(!collapsed)}
      >
        <p>{ModifierTypes[condition]?.name}</p>
        <i className="fas fa-chevron-down" />
      </div>

      <div
        className={css({
          collapsedCategories: true,
          in: collapsed,
          out: !collapsed,
        })}
      >
        <ul className={styles.options}>
          {Object.values(ModifierTypes).map((c) => {
            if (c.value === condition || !types.includes(c.value)) return false;

            return (
              <li
                onClick={() => {
                  onChange(c.value);
                  setCollapsed(false);
                }}
              >
                {c.name}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

const Variable = ({ variable, data, onChange }) => {
  let FormComponent = VariableForms[variable.type];

  if (!FormComponent && variable.type?.startsWith("customer_attributes_")) {
    FormComponent = CustomerAttributeTextForm;
  }

  if (!FormComponent) return null;

  return (
    <FormComponent
      variable={variable}
      data={data}
      key={variable.type}
      onChange={(updatedData) => onChange(updatedData)}
    />
  );
};

export default function Filters({
  visible,
  onClose,
  onApplyFilters,
  clearFilters,
  selected_filters,
  extra_variables,
}) {
  const [search, setSearch] = useState("");
  const [invalid, setInvalid] = useState(true);
  console.log("extra_variables", extra_variables);
  const allVariables = useMemo(
    () => [...Variables, ...(extra_variables || [])],
    [extra_variables]
  );

  const filteredVariables = allVariables.filter((b) =>
    !!search ? b.label.toLowerCase().indexOf(search.toLowerCase()) > -1 : true
  );

  const [selectedFilters, setSelectedFilters] = useState(
    selected_filters || []
  );

  useEffect(() => {
    if (!selected_filters || selected_filters?.length === 0)
      setSelectedFilters([]);
    else setSelectedFilters(selected_filters);
  }, [selected_filters]);

  useEffect(() => {

    const hasInvalidFilters = selectedFilters.filter((b) => {
      if (!b.active) {
        return false;
      }

      if (b.operand === "in_last" || b.type === "c.birthdate") {
        return !b.values;
      }

      const values = (b.values || []).filter((v) => !!v);
      return values.length == 0;

    }).length > 0;

    setInvalid(hasInvalidFilters);

  });

  const handleChange = (updatedData) => {
    setSelectedFilters((prevData) => [
      ...prevData.filter((d) => d.type !== updatedData.type),
      updatedData,
    ]);
  };

  const applyFilters = () => {
    onApplyFilters(selectedFilters.filter((b) => b.active));
  };

  const finalVariable = filteredVariables.map((labelItem) => {
    const dataItem = selectedFilters.find((d) => d.type === labelItem.type);
    return dataItem ? { ...labelItem, ...dataItem } : labelItem;
  });

  const activeFilters = finalVariable.filter((b) => b.active)?.length;

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      title="Filtros"
      subtitle={activeFilters > 0 ? `${activeFilters} aplicado(s)` : null}
    >
      <div className="d-flex align-center">
        <InputSearch
          placeholder="Buscar por..."
          design="two"
          className="flex-1"
          onChange={(e) => setSearch(e.target.value)}
        />
        {activeFilters > 0 && (
          <Button
            design="secondary-mini"
            onClick={() => {
              clearFilters();
              setSelectedFilters([]);
            }}
            className="ml-15"
          >
            Limpar filtros
          </Button>
        )}
      </div>

      <div className={styles.scrollContainer}>
        {activeFilters > 0 && (
          <>
            <ul className={styles.activeFilters}>
              <ForEach
                items={finalVariable.filter((b) => b.active)}
                render={(variable) => {
                  return (
                    <Variable
                      variable={variable}
                      data={selectedFilters.find(
                        (d) => d.type === variable.type
                      )}
                      onChange={handleChange}
                    />
                  );
                }}
              />
            </ul>
            <Hairline className="mt-20 mb-20" />
          </>
        )}

        <ul className={styles.filters}>
          <ForEach
            items={finalVariable.filter((b) => !b.active)}
            render={(variable) => {
              return (
                <Variable
                  variable={variable}
                  data={selectedFilters.find((d) => d.type === variable.type)}
                  onChange={handleChange}
                />
              );
            }}
          />
        </ul>
      </div>

      <div className={styles.footer}>
        <Button
          design="primary"
          className="w-100"
          disabled={
            JSON.stringify(selected_filters) === JSON.stringify(selectedFilters) || invalid
          }
          onClick={() => applyFilters()}
        >
          Aplicar
        </Button>
      </div>
    </Drawer>
  );
}
